import React, { Component, Fragment } from "react";
import { Pagination, message, Select } from "antd";
import Moment from "moment";
import {
  fetchPunishListData,
  fetchPageConfigData,
  fetchPunishTypeData,
  needChallenge,
  challengeResult,
  getPunishSummary,
} from "../../services/services";
import { getQueryString } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import Prompt from "../../components/prompt";
import ConditionMenu from "../../components/conditionMenu";
import punish from "../../static/images/punish.png";
import Loading from "../../components/loading";
import { withRouter } from "react-router-dom";
import styles from "./index.less";
interface State {
  displayControl: any;
  punishBusinessLineSearch: any;
  punishStateSearch: any;
  punishListData: any[];
  punishRecordTips: any;
  pageNo: number; //  列表页数
  pageSize: number;
  totalCount: number; // 每页数据数
  punishLine: string | number;
  punishStatus: string | number;
  error: boolean;
  loading: boolean;
  configLoading: boolean;
  punishTypeData: [],
  punishType: string | number,
  forbiddenDetail: any
}
interface Props {
  history: any;
  displayControl: any;
  punishBusinessLineSearch: any;
  punishStateSearch: any;
}

class PenaltyList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      displayControl: [], //控制处罚下拉列表显示与隐藏
      punishBusinessLineSearch: [], //业务线下拉列表数据
      punishStateSearch: [], //处罚状态下拉列表数据
      punishListData: [],
      punishRecordTips: '',
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      punishLine: "",
      punishStatus: "",
      error: false,
      loading: true,
      configLoading: true,
      punishTypeData: [],
      punishType: '',
      forbiddenDetail: []
    };
  }

  componentWillMount() {
    this.getPageConfigData();
    this.getPunishListData(1);
    this.getPunishType()
    burying("1", "punish-record-page", "undefined", "ss-01", "undefined");
  }
  getWeiliaoPunish = async () => {
    const templateId = getQueryString("templateId");
    const res = await getPunishSummary({ templateId });
    if (res.code === 0 && res.data.dataList && res.data.dataList.length) {
      this.setState({
        forbiddenDetail: res.data.dataList,
        punishListData: res.data.dataList.concat(this.state.punishListData),
      })
    }
  }

  /**
   * @description 获取处罚配置数据
   *
   **/
  getPageConfigData = async () => {
    const templateId = getQueryString("templateId");
    const result = await fetchPageConfigData(templateId);
    if (result) {
      if (result.code === 0) {
        const {
          displayControl,
          punishBusinessLineSearch,
          punishStatus,
          punishRecordTips
        } = result.data;
        if (displayControl.need_wlmutePunish === 1) {
          this.getWeiliaoPunish();
        }
        this.setState({
          displayControl,
          punishBusinessLineSearch,
          punishStateSearch: punishStatus,
          punishRecordTips
        });
      } else {
        message.info(result.msg);
      }
      this.setState({
        configLoading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 获取处罚列表数据
   *
   **/
  getPunishListData = async (
    pageNo: number,
    pageSize?: number,
    punishLine?: string | number,
    punishStatus?: string | number
  ) => {
    const templateId = getQueryString("templateId");
    const infoId = getQueryString("infoId");
    const params = {
      templateId,
      infoId,
      punishLine: punishLine ? punishLine : this.state.punishLine,
      punishType: this.state.punishType,
      punishStatus: punishStatus ? punishStatus : this.state.punishStatus,
      pageNo,
      pageSize: pageSize ? pageSize : this.state.pageSize,
    };
    const result = await fetchPunishListData(params);
    if (result) {
      if (result.code === 0) {
        const { dataList = [], totalCount } = result.data;
        this.setState({
          // 如果有微聊禁言的记录，将微聊禁言的记录放在列表的最前面
          punishListData: this.state.displayControl.need_wlmutePunish && ['-1', ''].includes(String(this.state.punishType)) && pageNo === 1 ? this.state.forbiddenDetail.concat(dataList) : dataList,
          totalCount,
          error: false,
        });
      } else {
        message.info(result.msg);
        this.setState({
          error: true,
        });
      }
      this.setState({
        loading: false,
      });
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 选择处罚状态查询
   *
   **/
  getPunishmentState = async (punishStatus: string | number) => {
    await this.setState({
      punishStatus,
    });
    this.getPunishListData(
      1,
      this.state.pageSize,
      this.state.punishLine,
      punishStatus
    );
    burying(
      "2",
      "filter-punish-record",
      `business=${this.state.punishLine}$valid=1$status=${punishStatus}`,
      "ss-01",
      "undefined"
    );
  };

  /**
   * @description 选择业务线查询
   *
   **/
  getPunishLine = async (punishLine: string | number) => {
    await this.setState({
      punishLine,
    });
    this.getPunishListData(
      1,
      this.state.pageSize,
      punishLine,
      this.state.punishStatus
    );
    burying(
      "2",
      "filter-punish-record",
      `business=${punishLine}$valid=1$status=${this.state.punishStatus}`,
      "ss-01",
      "undefined"
    );
  };

  /**
   * @description 分页查询
   *
   **/
  pageChange = (page: number, size: number) => {
    const { pageSize } = this.state;
    if (pageSize !== size) {
      this.setState({
        pageNo: 1,
        pageSize: size,
      });
      this.getPunishListData(1, size);
    } else {
      this.setState({
        pageNo: page,
        pageSize: size,
      });
      this.getPunishListData(page, size);
    }
  };

  /**
   * @description 跳转到处罚详情页
   *
   **/
  linkToPenaltyDetails = (
    punishId: number | string,
    punishStatus: number | string,
    punishNames: number,
  ) => {
    const templateId = getQueryString("templateId");
    this.props.history.push(
      punishNames[0] === '微聊禁言' ? `/case/home/punish/detail/${punishId}?templateId=${templateId}&punishId=${punishId}&punishLine=${this.state.punishLine}&punishStatus=${punishStatus}&isWlPunish=true` : `/case/home/punish/detail/${punishId}?templateId=${templateId}&punishId=${punishId}&punishLine=${this.state.punishLine}&punishStatus=${punishStatus}`
    );
  };

  /**
   * @description 跳转到申诉详情页
   *
   **/
  linkToAppealDetails = (caseId: string | number, appealStatus: number) => {
    const templateId = getQueryString("templateId");

    this.props.history.push(
      `/case/home/detail/${caseId}?templateId=${templateId}&caseId=${caseId}&appealStatus=${appealStatus}`
    );
  };

  /**
   * @description 跳转到申诉页
   *
   **/
  linkToAppealPage = (punishId: number | string) => {
    const templateId = getQueryString("templateId");
    this.props.history.push(
      `/case/home/appealentrance?templateId=${templateId}&punishId=${punishId}`
    );
  };

  /**
   * @description 处罚申诉tab切换
   *
   **/
  changePenaltyAppeal = () => {
    const templateId = getQueryString("templateId");
    burying(
      "2",
      "appealrecord-punish-record",
      "undefined",
      "ss-01",
      "undefined"
    );
    this.props.history.push(`/case/home/list?templateId=${templateId}`);
  };

  /**
   * @description 格式化时间
   *
   **/
  renderTime = (punishTime) => {
    return (
      <Fragment>
        <span className={styles.date}>
          {Moment(punishTime).format("YYYY-MM-DD")}
        </span>
        {/* <span className={styles.time}>
          {Moment(punishTime).format("HH:mm")}
        </span> */}
      </Fragment>
    );
  };
  /**
   * @description 获取处罚配置数据
   *
   **/
  async getPunishType() {
    const templateId = getQueryString("templateId");
    const result = await fetchPunishTypeData({ templateId, punishLine: this.state.punishLine });
    if (result) {
      if (result.code === 0) {
        this.setState({ punishTypeData: result.data })
      } else {
        message.info(result.msg);
      }

    } else {
      this.props.history.push("/case/home/error");
    }

  }
  handleSelect(item) {
    if (item === "-1") {
      this.setState({ punishListData: this.state.forbiddenDetail })
      return;
    }
    this.setState({ punishType: item }, () => {
      this.getPunishListData(1);
    })

  }
  handleAppeal = (item: any) => {
    const { illegalType, punishId, punishNames } = item;
    if (illegalType == 1 && punishNames[0] === '微聊禁言') {
      // 非虚假类罚单
      this.handleChallenge(punishId);
      return;
    }
    burying(
      "2",
      "ifpunish-punish-record",
      "status=0",
      "ss-01",
      "undefined"
    );
    // 如果是虚假类罚单
    if (illegalType == 2) {
      message.info('请到58同城APP："我的—客户服务—处罚申诉"找到对应处罚记录提交申诉');
      // window.location.href = `https://zfang.58.com/post/pc/houseappeal?houseId=${hoursId}`
    } else {
      this.linkToAppealPage(punishId);
    }
  }
  handleChallenge = async (punishId: number | string) => {
    const templateId = getQueryString('templateId');
    // 获取挑战结果
    const challengeRes = await needChallenge({ templateId });
    // 如果需要挑战则唤起挑战
    if (challengeRes.data.needChallenge) {
      const { accessPartyID, appID, sceneID, challengeLevel, sessionID, userID } = challengeRes.data;
      window.yChallenge({
        appId: appID,
        sceneId: sceneID,
        additional: {
          challengelevel: String(challengeLevel),
        },
        sessionId: sessionID,
        userId: userID,
        accesspartyId: accessPartyID,
        callback: async function (result: any) {
          if (result && result.code === 0) {
            const challengeRes = await challengeResult({ templateId, token: result.token });
            if (challengeRes && challengeRes.code === 0) {
              message.success('挑战成功');
            } else {
              message.success('挑战失败');
            }
          } else {
            message.success('挑战失败');
          }
          window.location.reload();
        },
      })
    } else {
      this.linkToAppealPage(punishId);
    }
  }
  render() {
    const {
      punishListData,
      totalCount,
      displayControl,
      punishBusinessLineSearch,
      punishStateSearch,
      punishRecordTips,
      error,
      loading,
      configLoading,
      pageNo,
      punishTypeData,
      forbiddenDetail
    } = this.state;
    const {
      need_punish_business_search,
      need_punish_status_search,
    } = displayControl;
    const templateId = getQueryString('templateId')
    return (
      <div style={{ width: templateId === "2" ? "" : "815px" }}>
        <div className={styles.penalty}>
          <div className={styles.header}>
            {displayControl.need_punishCaseList === 1 ? (
              <Fragment>
                <span className={styles.active}>处罚记录</span>
                <span
                  className={styles.disActive}
                  onClick={this.changePenaltyAppeal}
                >
                  申诉记录
                </span>
              </Fragment>
            ) : (
              <span className={styles.active}>处罚记录</span>
            )}
          </div>
          {loading || configLoading ? (
            <Loading />
          ) : (

            <div className={styles.penaltyList}>
              <div className={styles.conditionMenu}>
                <Select
                  style={{ width: "30%" }}
                  defaultValue={"选择处罚类型"}
                  onSelect={this.handleSelect.bind(this)}
                >
                  <Select.Option value="" key="">
                    不限
                  </Select.Option>
                  {displayControl.need_wlmutePunish === 1 && forbiddenDetail.length && <Select.Option value="-1" key="-1">
                    微聊禁言
                  </Select.Option>}
                  {punishTypeData.map((item: any) => {
                    return (
                      <Select.Option value={item.punishType} key={item.punishType}>
                        {item.punishTypeName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </div>
              {need_punish_business_search === 1 ||
                need_punish_status_search === 1 ? (
                <div className={styles.conditionMenu}>
                  {need_punish_business_search === 1 ? (
                    <ConditionMenu
                      displayControl={displayControl}
                      menuList={punishBusinessLineSearch}
                      getConditionId={this.getPunishLine}
                      type="punish"
                      defaultValue="选择业务线"
                    />
                  ) : null}
                  {need_punish_status_search === 1 ? (
                    <ConditionMenu
                      displayControl={displayControl}
                      menuList={punishStateSearch}
                      getConditionId={this.getPunishmentState}
                      type="punish"
                      defaultValue="全部"
                    />
                  ) : null}
                </div>
              ) : null}
              <ul className={styles.penaltyTable}>
                <div className={styles.penaltyListTitle}>
                  <span className={styles.singlePunishment}>处罚单</span>
                  <span className={styles.penaltyReason}>处罚原因</span>
                  <span className={styles.punishmentDate}>处罚日期</span>
                  <span className={styles.punishmentState}>处罚状态</span>
                  <span className={styles.operation}>操作</span>
                </div>
                {error ? (
                  <Prompt
                    path="//j1.58cdn.com.cn/arthurupload/arthurlocalpush/ysk/icon500.png"
                    tip={"系统维护中，请稍等~"}
                  />
                ) : punishListData && punishListData.length > 0 ? (
                  punishListData.map((item: any, index: number) => {
                    const {
                      caseId,
                      punishId,
                      punishReason,
                      punishTime,
                      punishStatus,
                      caseButtonType,
                      punishNames,
                      appealStatus,
                      recovery,
                      showPunishConfig,
                      illegalType,
                      // hoursId,
                    } = item;

                    const isWeiliaoPunish = item.punishNames && punishNames[0] === '微聊禁言';
                    const reasonList = punishReason ? punishReason.split('|') : [];
                    return (
                      <li className={styles.punishmentRecord} key={index}>
                        <div className={styles.singlePunishmentContent}>
                          <img className={styles.punishImg} src={punish} />
                          <div className={styles.punishInfo}>
                            <span className={styles.punishNames}>
                              处罚方式：
                              {punishNames &&
                                punishNames.map((item: string, index: number) => {
                                  return (
                                    <i key={index}>
                                      {item}
                                      {index !== punishNames.length - 1
                                        ? ","
                                        : ""}
                                    </i>
                                  );
                                })}
                            </span>
                            {!isWeiliaoPunish && <span>处罚编号：{punishId}</span>}
                          </div>
                        </div>
                        <div className={styles.penaltyReasonContent}>
                          {isWeiliaoPunish ?
                            <div className={styles.weiliaoPunish}>
                              {reasonList.length > 0 ? reasonList.map((reason: string, index: number) =>
                                <span
                                  className={styles.wlReason}
                                  style={{ WebkitBoxOrient: "vertical" }}>
                                  {reasonList.length > 1 ? `${index + 1}. ${reason}` : `${reason}`}
                                </span>
                              ) : null}
                            </div> : <div
                              className={styles.punishReason}
                              style={{ WebkitBoxOrient: "vertical" }}
                            >
                              {punishReason}
                            </div>}
                        </div>
                        <div className={styles.punishmentDateContent}>
                          {this.renderTime(punishTime)}
                        </div>
                        <div className={styles.punishmentStateContent}>
                          {appealStatus === 5 ? (
                            <i className={styles.firstState}>处罚维持原判</i>
                          ) : recovery ||
                            appealStatus === 4 ||
                            punishStatus === 3 ||
                            punishStatus === 2 ? (
                            <i className={styles.secondState}>处罚已撤销</i>
                          ) : (
                            <i className={styles.thirdState}>已处罚</i>
                          )}
                        </div>
                        <div className={styles.operationContent}>
                          <i
                            onClick={() => {
                              burying(
                                "2",
                                "detail-punish-record",
                                "undefined",
                                "ss-01",
                                caseId
                              );
                              this.linkToPenaltyDetails(punishId, appealStatus, punishNames);
                            }}
                          >
                            处罚详情
                          </i>
                          {caseButtonType && caseButtonType !== -1 ? (
                            caseButtonType === 1 ? (
                              <i
                                onClick={() => {
                                  burying(
                                    "2",
                                    "ifpunish-punish-record",
                                    "status=1",
                                    "ss-01",
                                    "undefined"
                                  );
                                  if (illegalType == 2) {
                                    message.info('请到58同城APP："我的—客户服务—处罚申诉"找到对应处罚记录提交申诉');
                                    // window.location.href = `https://zfang.58.com/post/pc/houseappeal?houseId=${hoursId}`
                                  } else {
                                    this.linkToAppealDetails(caseId, punishStatus);
                                  }
                                }}
                              >
                                已申诉
                              </i>
                            ) : (
                              <i
                                onClick={() => this.handleAppeal(item)}
                              >
                                申诉
                              </i>
                            )
                          ) : null}
                          {showPunishConfig &&
                            showPunishConfig.buttonProtocolType === 1 ? (
                            <i>{showPunishConfig.buttonText}</i>
                          ) : null}
                          {showPunishConfig &&
                            showPunishConfig.buttonProtocolType === 0 &&
                            showPunishConfig.buttonText ? (
                            <a
                              onClick={() => {
                                window.open(showPunishConfig.buttonUrl);
                                burying(
                                  "2",
                                  "ifpunish-punish-record",
                                  "status=2",
                                  "ss-01",
                                  "undefined"
                                );
                              }}
                            >
                              {showPunishConfig.buttonText}
                            </a>
                          ) : null}
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <Prompt
                    path="//j1.58cdn.com.cn/arthurupload/arthurlocalpush/ysk/empty.png"
                    tip={"近一年内，未查到您有处罚记录。要继续保持哦～"}
                    punishRecordTips={punishRecordTips}
                  />
                )}
              </ul>
              {punishListData && punishListData.length > 0 && !error ? (
                <div className={styles.pagination}>
                  <Pagination
                    current={pageNo}
                    defaultCurrent={1}
                    total={totalCount}
                    size="small"
                    onChange={this.pageChange}
                  />
                </div>
              ) : null}
            </div>
          )}
        </div>

      </div>
    );
  }
}

export default withRouter(PenaltyList);
